import { Cell } from 'modules/admin/Common';
import CommonAssetAdmin from 'modules/admin/CommonAssetAdmin';
import React from 'react';
import { connect } from 'rxbeach/react';
import NewsEditor from './NewsEditor';
import { newsViewModel$ } from './news$';

const columns = [
  {
    header: 'Tittel',
    property: 'label',
    search: true,
    render: (e: any) => <Cell>{e.label}</Cell>,
  },
  {
    header: 'Publisert',
    property: 'published',
    verticalAlign: 'middle',
    align: 'center',
    render: (e: any) => <Cell>{e.published ? '✅' : '⚠️'}</Cell>,
  },
  {
    header: 'Fremhev',
    property: 'featured',
    verticalAlign: 'middle',
    align: 'center',
    render: (e: any) => <Cell>{e.featured ? '⭐️' : ''}</Cell>,
  },
];

const NewsAdmin = ({ news, byId }: any) => {
  return (
    <CommonAssetAdmin
      data={news}
      byId={byId}
      columns={columns}
      Editor={NewsEditor}
    />
  );
};

export default connect(NewsAdmin, newsViewModel$);
